export interface ActionBarButton {
  id: string;
  labelKey: string;
  onClick(): void;
  disabled?: boolean;
  /** Marks the button as the currently-selected one (highlighted). */
  active?: boolean;
  /** Inline SVG markup; when present it replaces the text label and `labelKey`
   * becomes the button's accessible name + tooltip. */
  iconSvg?: string;
}

export interface ActionBarHandle {
  setButtons(buttons: readonly ActionBarButton[]): void;
  destroy(): void;
}

export function createActionBar(
  root: HTMLElement,
  initial: readonly ActionBarButton[],
): ActionBarHandle {
  function render(buttons: readonly ActionBarButton[]): void {
    root.replaceChildren();
    for (const b of buttons) {
      const btn = document.createElement('button');
      btn.className = b.active ? 'arith-actionbar-btn active' : 'arith-actionbar-btn';
      btn.dataset.actionId = b.id;
      if (b.iconSvg) {
        btn.innerHTML = b.iconSvg;
        btn.setAttribute('aria-label', b.labelKey);
        btn.title = b.labelKey;
      } else {
        btn.textContent = b.labelKey;
      }
      if (b.active) btn.setAttribute('aria-pressed', 'true');
      if (b.disabled) btn.disabled = true;
      btn.addEventListener('click', () => b.onClick());
      root.appendChild(btn);
    }
  }

  render(initial);
  return {
    setButtons(next) {
      render(next);
    },
    destroy() {
      root.replaceChildren();
    },
  };
}
